import { APP_CONFIG } from '@/config/constants';

export interface WelcomeScreenOptions {
  title: string;
  description: string;
  onStart: () => void;
}

export class WelcomeScreen {
  private container: HTMLElement;
  private options: WelcomeScreenOptions;

  constructor(parentElement: HTMLElement, options: WelcomeScreenOptions) {
    this.options = options;
    this.container = document.createElement('div');
    this.container.className = 'welcome-screen';

    this.render();
    parentElement.appendChild(this.container);
  }

  private render(): void {
    this.container.innerHTML = `
      <img src="${APP_CONFIG.LOGO_PATH}" alt="${APP_CONFIG.COMPANY_NAME}" class="logo logo-white">
      <h1>${this.options.title}</h1>
      <p>${this.options.description}</p>
      <button class="btn-start">Iniciar Diagnóstico</button>
    `;

    const startButton = this.container.querySelector('.btn-start') as HTMLButtonElement;
    startButton.addEventListener('click', () => this.options.onStart());
  }

  remove(): void {
    this.container.remove();
  }

  getElement(): HTMLElement {
    return this.container;
  }
}
